import { X } from "lucide-react"; // Import icons
import { twMerge } from "tailwind-merge";
import deleteIcon from "../../assets/icons/deleteIcon.svg";
import confirmIcon from "../../assets/icons/confirmIcon.svg";

export const ConfirmationModal = ({ isOpen, options, onConfirm, onCancel }) => {
  if (!isOpen) return null;

  // Dynamic Text Color
  const typeBasedTextColor =
    options.type === "accept"
      ? "text-[#00796B]"
      : options.type === "delete"
      ? "text-[#C90303]"
      : "text-gray-800";

  // Dynamic Button Background Color
  const typeBasedButtonBg =
    options.type === "accept"
      ? "bg-[#FF0202]"
      : options.type === "delete"
      ? "bg-[#C90303]"
      : "bg-gray-600";

  const typeBasedBorderColor =
    options.type === "accept"
      ? "border-[#FF0202]"
      : options.type === "delete"
      ? "border-[#0F161E]"
      : "bg-gray-600 hover:bg-gray-700";

  const typeBasedConfirmButtonColor =
    options.type === "accept"
      ? "bg-[#FF0202]"
      : options.type === "delete"
      ? "bg-[#C90303]"
      : "bg-gray-600 hover:bg-gray-700";

  const typeBasedCancelBorderColor =
    options.type === "accept"
      ? "border-[#FF0202] text-[#FF0202]"
      : options.type === "delete"
      ? "border-[#C90303] text-[#C90303]"
      : "border-gray-600 text-gray-600 hover:bg-gray-600";

  const icon = options.type === "accept" ? confirmIcon : deleteIcon;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      {/* Modal Container */}
      <div
        className={twMerge(
          "bg-white rounded-[10px] w-[391px] max-w-[90%] border border-[#E5E5E5] px-[41px] py-[32px] shadow-md relative"
        )}
      >
        {/* Close Button */}
        <button
          onClick={onCancel}
          className="absolute text-[#707070] right-4 top-4 hover:text-gray-700"
        >
          <X size={24} />
        </button>

        {/* Content */}
        <div className="flex flex-col items-center mb-[30px]">
          {/* Icon */}
          <div className="flex items-center justify-center gap-3 mb-5">
            <div>
              {options.type === "approve" || options.type === "reject" ? (
                icon
              ) : (
                <img src={icon} alt="Alert icon" />
              )}
            </div>
            <p className="font-inter font-medium text-[#071952] text-[18px]">
              {options.title || "Delete Property"}
            </p>
          </div>

          {/* Message */}
          <p className="font-inter text-[#707070] text-[14px] text-center leading-5 mb-4">
            {options.message ||
              "Are you sure you want to delete this property? This will remove all associated units."}
          </p>

          {/* Details/Points */}
          {options.details && options.details.length > 0 && (
            <div className="w-full">
              <ul className="text-left space-y-2">
                {options.details.map((detail, index) => (
                  <li key={index} className="font-inter text-[#707070] text-[12px] leading-4 flex items-start">
                    <span className="text-[#707070] mr-2 font-bold">•</span>
                    <span>{detail}</span>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>

        {/* Action Buttons */}
        <div className="flex justify-center gap-4">
          {/* Cancel Button */}
          <button
            onClick={onCancel}
            className={`w-[66px] h-[30px] border ${typeBasedCancelBorderColor} rounded-[3.77px] font-inter font-medium text-xs uppercase`}
          >
            {options.cancelText || "CANCEL"}
          </button>

          {/* Confirm Button */}
          <button
            onClick={onConfirm}
            className={`w-[66px] h-[30px] ${typeBasedConfirmButtonColor} uppercase text-white rounded-[3.77px] font-inter font-medium text-xs transition`}
          >
            {options.confirmText || "DELETE"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
